<template>
  <article-layout
    :nid="nid"
    :title="title"
    :media="media"
    :caption="caption"
    :lead="lead"
    :body="body"
    :advertisement="advertisement"
  >
    <template #meta>
      <article-layout-meta
        v-if="seriesList"
        :title="$texts('more_related_articles', 'Verwandte Artikel anzeigen')"
      >
        <link-list title="" :links="seriesList" />
      </article-layout-meta>
      <article-layout-meta
        v-if="links?.length"
        :title="$texts('links', 'Links')"
      >
        <link-list :links="links" />
      </article-layout-meta>
      <article-layout-meta
        v-if="categories"
        :title="$texts('categories', 'Kategorien')"
      >
        <link-list :links="categoriesList" link-class="tag is-warning" />
      </article-layout-meta>
      <article-layout-meta
        v-if="documents"
        :title="$texts('documents', 'Dokumente')"
      >
        <!-- @TODO: Das ist kein Array in GraphQL. -->
        <media-document
          v-for="document in documents"
          :key="document?.entity?.fid"
          :file="document"
        />
      </article-layout-meta>
      <article-layout-meta :title="$texts('author', 'Autor')">
        <p>{{ author }}</p>
      </article-layout-meta>
    </template>
    <template #footer>
      <node-article-related :nid="nid" :tids="tagIds" />
      <section class="section">
        <div class="container">
          <comment-comment
            v-for="comment in comments"
            v-bind="comment"
            :key="comment.cid"
          />
          <div ref="add-comment">
            <forms-comment :nid="nid" />
          </div>
        </div>
      </section>
    </template>
  </article-layout>
</template>

<script setup lang="ts">
import type {
  CommentCommentFragment,
  NodeArticleFragment,
} from '#graphql-operations'

const props = defineProps<{
  uuid: string
  nid?: number
  title?: string
  body?: string
  lead?: string
  media?: NodeArticleFragment['media']
  categories?: NodeArticleFragment['categories']
  series?: NodeArticleFragment['series']
  links: NodeArticleFragment['links']
  author?: NodeArticleFragment['author']
  documents?: NodeArticleFragment['documents']
  tags?: NodeArticleFragment['tags']
  advertisement?: NodeArticleFragment['advertisement']
}>()

const { $texts } = useNuxtApp()

const { data: comments } = await useAsyncData(async () => {
  const random = (Math.random() + 1).toString(36).substring(7)
  const variables = {
    nid: '' + props.nid,
    random,
  }

  return await useGraphqlQuery('commentsPerNode', variables).then((v) => {
    return (v.data.entityQuery.entities || []) as CommentCommentFragment[]
  })
})

const caption = computed(() => props.media?.caption ?? '')
const seriesList = computed(() => props.series?.map((element) => element) || [])
const tagIds = computed(() => props.tags?.map((element) => element?.tid) ?? [])

// const commentList = computed(() =>
//   comments.value.filter((el: any) => el != null),
// )
const categoriesList = computed(() => [props.categories].map((v) => v))
</script>
